module.exports = __webpack_public_path__ + "static/media/compressor.3726fbeb.webp";